const env = window.__ENV__ || {};

const auth0Config = {
  domain: env.REACT_APP_AUTH0_DOMAIN || process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: env.REACT_APP_AUTH0_CLIENT_ID || process.env.REACT_APP_AUTH0_CLIENT_ID,
  redirectUri: window.location.origin,
  audience: env.REACT_APP_AUTH0_AUDIENCE || process.env.REACT_APP_AUTH0_AUDIENCE,
  scope: "openid profile email read:roles"
};

// Debug: Log environment variables in development
if (process.env.NODE_ENV === 'development') {
}

export default auth0Config; 